import { useMemo, useState, type MouseEvent } from 'react';
import { ImageLightbox } from './ImageLightbox';
import styles from './RichContent.module.css';
import { sanitizeRichContent } from './sanitizeRichContent';

interface RichContentProps {
    html: string;
}

/** Unico ponto do app que renderiza HTML vindo do servidor. */
export function RichContent({ html }: RichContentProps) {
    // O objeto precisa ser o mesmo entre renders: o React compara por referencia e,
    // se mudar, reescreve o HTML e reinicia o video que esta tocando.
    const markup = useMemo(() => ({ __html: sanitizeRichContent(html) }), [html]);
    const [zoomed, setZoomed] = useState<{ src: string; alt: string } | null>(null);

    const handleClick = (e: MouseEvent<HTMLDivElement>) => {
        const target = e.target;
        // Imagem dentro de link continua abrindo o link.
        if (!(target instanceof HTMLImageElement) || target.closest('a')) return;
        setZoomed({ src: target.currentSrc || target.src, alt: target.alt });
    };

    return (
        <>
            <div className={styles.content} onClick={handleClick} dangerouslySetInnerHTML={markup} />
            {zoomed && <ImageLightbox src={zoomed.src} alt={zoomed.alt} onClose={() => setZoomed(null)} />}
        </>
    );
}
